import { Flex } from "@chakra-ui/react";
import { GoChevronRight } from "react-icons/go";

import { InputField } from "./InputField";
import { CustomIconButton } from "../CustomIconButton";

import type { ContactFormStepProps } from "./ContactForm";

export const ContactFormStep1 = (props: ContactFormStepProps) => {
	const { isFinalStep = false, setFormStep, ...fieldProps } = props;
	return (
		<Flex gap="4" align="flex-start" w="md">
			<InputField
				label="name"
				field="name"
				{...fieldProps}
				isFinalStep={isFinalStep}
				error="what should i call you?"
			/>

			<InputField
				label="contact"
				field="contact"
				error="email or mobile?"
				isFinalStep={isFinalStep}
				{...fieldProps}
			/>

			{!isFinalStep && setFormStep && (
				<CustomIconButton
					icon={<GoChevronRight />}
					onClick={() => setFormStep(2)}
				/>
			)}
		</Flex>
	);
};
